import React, { useContext, useState } from "react";
import "./style.scss";
import { useFormik } from "formik";
import { UserGlobalContextMemorySpace } from "../../../contexts/user/userGlobalContext";
import { Button } from "react-bootstrap";
import { useEffect } from "react";
import { myAxios } from "../../../utils/fetch";
import { useToggle } from "../../../hooks/useToggle";
import { ModalConfirmChangeComponent } from "../../pshb/add-refund/confirm-change";
import { MessageContext } from "../../pshb/add-refund/context";
import { Grid, IconButton, List, ListItem, ListItemText } from "@mui/material";
import { validate } from "./validationSchema";
import { styled } from "@mui/material/styles";
import imgEliminar from "../../../assets/img/eliminar.png";
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Select from "react-select";
import searchIcon from "../../../assets/img/hb/search-select.svg";
import CryptoJS from "crypto-js";

const calculateFileHash = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const wordArray = CryptoJS.lib.WordArray.create(e.target.result);
      const hash = CryptoJS.MD5(wordArray).toString();
      resolve(hash);
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
};

const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: "38px",
    borderRadius: "20px",
    borderColor: "#ced4da",
    boxShadow: "0px 10px 11px -8px rgba(0, 73, 144, 0.2)",
    backgroundColor: "white",
    backgroundImage: `url(${searchIcon})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "12px center",
    backgroundSize: "14px 14px",
    fontFamily: "Roboto-Regular",
    fontSize: "16px",
    "&:hover": {
      borderColor: "#ced4da",
    },
    ...(state.isFocused
      ? {
          borderColor: "#ced4da",
          boxShadow: "0px 10px 11px -8px rgba(0, 73, 144, 0.2)",
        }
      : {}),
  }),
  valueContainer: (base) => ({
    ...base,
    paddingLeft: "34px",
    paddingRight: "12px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#6c757d",
    fontFamily: "Roboto-Regular",
    fontSize: "16px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: "#05294f",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#05294f",
    fontFamily: "Roboto-Regular",
    fontSize: "16px",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#e9ecef" : state.isFocused ? "#f8f9fa" : "white",
    color: "#05294f",
    fontFamily: "Roboto-Regular",
    fontSize: "16px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 20,
    marginTop: "2px",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "220px",
    paddingTop: 0,
    paddingBottom: 0,
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#05294f",
    paddingRight: "10px",
  }),
};

const AdjuntarDocumentacionComponent = () => {
  const [loading, setLoading] = useState(false);
  const { user } = useContext(UserGlobalContextMemorySpace);
  const [ dni, setDni] = useState();
  const [CentroMedicos, setCentroMedicos] = useState([]);
  const [CentroMedicoSelected, setCentroMedicoSelected] = useState({
    id: null,
    name: "Seleccione"
  });

  const [especialidades, setEspecialidades] = React.useState([]);
  const [especialidadSelected, setEspecialidadSelected] = useState({
    id: null,
    name: "Seleccione"
  });
  const MessageToggle = useToggle();
  const [responseData, setResponseData] = useState({
    message: "",
    message2: "",
    error: false,
    icon: "",
    iconColor: ""
  });
  const Demo = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
  }));

  useEffect(() => {
    if (user?.user?.data?.Customers?.dni) {
      setDni(user.user.data.Customers.dni);
    }
  }, [user]);

  const formik = useFormik({
    initialValues: {
      dni: dni,
      idCentroMedico: CentroMedicoSelected.id,
      idEspecialidad: especialidadSelected.id,
      documentsFileA: [],
      documentsFileO: [],
    },
    enableReinitialize: true,
    validationSchema: validate,
    onSubmit: (values) => {
      
      const errors = {};

      // Validación manual: Si centro médico es 1, especialidad debe ser seleccionada
      if (CentroMedicoSelected.id == 1 && (especialidadSelected.id === null || especialidadSelected.id === undefined)) {
        errors.idEspecialidad = "Debe seleccionar una especialidad";
      }

      if (values.documentsFileA.length === 0 && values.documentsFileO.length === 0) {
        errors.documentsFileA = "Seleccione al menos un archivo";
      }

      // Si hay errores, se setean y se detiene el submit
      if (Object.keys(errors).length > 0) {
        formik.setErrors(errors);
        return;
      }
      
      guardarDocumentacionAdjunta(values);
      limpiarFormulario();
    },
  });

  const guardarDocumentacionAdjunta = async (values) => {
    setLoading(true);
    let res = await myAxios({
      url:
        process.env.REACT_APP_GATEWAY_2 +
        "/patient/api/v1/documentosadjuntos/save",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.user.data.appToken}`,
      },
      data: values,
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        setLoading(false);
        setResponseData({ message: "Error!", icon: "error" });
        MessageToggle.onToggle();
      });

    if (res.data.responseCode == 200) {
      setLoading(false);
      setResponseData({ message: "Documentos enviados", icon: "success" });
      MessageToggle.onToggle();
    } else {
      setLoading(false);
      setResponseData({ message: "Error!", icon: "error" });
      MessageToggle.onToggle();
    }
  };

  const MAX_FILES = 5;
  const ALLOWED_TYPES = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

  const [fileList, setFileList] = useState([]);
  const handleFileChangeA = async (event, tipo) => {
    const files = Array.from(event.target.files);
    const validFiles = [];

    for (const file of files) {
      if (!ALLOWED_TYPES.includes(file.type)) {
        setResponseData({ message: "Solo se permiten imágenes JPG, JPEG, PNG y PDF.", icon: "error" });
        MessageToggle.onToggle();
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        setResponseData({ message: "Por favor verifica que tu archivo pese menos de 5 MB.", icon: "error" });
        MessageToggle.onToggle();
        return;
      }

      const fileHash = await calculateFileHash(file);

      const isDuplicateInA = fileList.some((f) => f.hash === fileHash);
      const isDuplicateInO = fileListO.some((f) => f.hash === fileHash);
      const isDuplicate = isDuplicateInA || isDuplicateInO;

      if (isDuplicate) {
        setResponseData({
          message: "Archivo duplicado",
          message2: "No puedes reutilizar el mismo archivo en autorizaciones y órdenes clínicas.",
          icon: "info",
          iconColor: "red",
        });
        MessageToggle.onToggle();
        return;
      }

      validFiles.push({ file, hash: fileHash });
    }

    if (validFiles.length + fileList.filter(f => f.tipo === tipo).length > MAX_FILES) {
      setResponseData({
        message: `El límite de archivos es ${MAX_FILES} por envío.`,
        message2: "Si necesitás agregar más, podés completar este envío y cargar el resto en uno nuevo.",
        icon: "info-error",
      });
      MessageToggle.onToggle();
      return;
    }

    const newFileList = [...fileList];
    const base64Files = [...formik.values.documentsFileA];

    let processedCount = 0;

    validFiles.forEach((fileObj) => {
      const { file, hash } = fileObj;
      const reader = new FileReader();
      reader.onload = function (e) {
        const base64String = e.target.result;

        const fileData = {
          autorizacionFile: file.name,
          autorizacionBase64File: base64String,
          tipo: tipo,
          hash: hash,
        };

        newFileList.push(fileData);
        base64Files.push(fileData);
        processedCount++;

        if (processedCount === validFiles.length) {
          setFileList(newFileList);
          formik.setValues({
            ...formik.values,
            documentsFileA: base64Files,
          });
        }
      };
      reader.readAsDataURL(file);
    });

    event.target.value = null;
  };

  const [fileListO, setFileListO] = useState([]);
  const MAX_FILES_O = 5;
  const ALLOWED_TYPES_O = ["application/pdf", "image/png", "image/jpeg"];
  const MAX_FILE_SIZE_O = 5 * 1024 * 1024; // 5MB

  const handleFileChangeO = async (event, tipo) => {
    const files = Array.from(event.target.files);
    const validFiles = [];

    for (const file of files) {
      if (!ALLOWED_TYPES_O.includes(file.type)) {
        setResponseData({ message: "Solo se permiten imágenes JPG, JPEG, PNG y PDF.", icon: "error" });
        MessageToggle.onToggle();
        return;
      }
      if (file.size > MAX_FILE_SIZE_O) {
        setResponseData({ message: "Por favor verifica que tu archivo pese menos de 5 MB.", icon: "error" });
        MessageToggle.onToggle();
        return;
      }

      const fileHash = await calculateFileHash(file);

      const isDuplicateInA = fileList.some((f) => f.hash === fileHash);
      const isDuplicateInO = fileListO.some((f) => f.hash === fileHash);
      const isDuplicate = isDuplicateInA || isDuplicateInO;

      if (isDuplicate) {
        setResponseData({
          message: "Archivo duplicado",
          message2: "No puedes reutilizar el mismo archivo en autorizaciones y órdenes clínicas.",
          icon: "info",
          iconColor: "red",
        });
        MessageToggle.onToggle();
        return;
      }

      validFiles.push({ file, hash: fileHash });
    }

    if (validFiles.length + fileList.filter(f => f.tipo === tipo).length > MAX_FILES_O) {
      setResponseData({
        message: `El límite de archivos es ${MAX_FILES} por envío.`,
        message2: "Si necesitás agregar más, podés completar este envío y cargar el resto en uno nuevo.",
        icon: "info-error",
      });
      MessageToggle.onToggle();
      return;
    }

    const newFileList = [...fileListO];
    const base64Files = [...formik.values.documentsFileO];

    let processedCount = 0;

    validFiles.forEach((fileObj) => {
      const { file, hash } = fileObj;
      const reader = new FileReader();
      reader.onload = function (e) {
        const base64String = e.target.result;

        const fileData = {
          ordenMedicaFile: file.name,
          ordenMedicaBase64File: base64String,
          tipo: tipo,
          hash: hash,
        };

        newFileList.push(fileData);
        base64Files.push(fileData);
        processedCount++;

        if (processedCount === validFiles.length) {
          setFileListO(newFileList);
          formik.setValues({
            ...formik.values,
            documentsFileO: base64Files,
          });
        }
      };
      reader.readAsDataURL(file);
    });

    event.target.value = null;
  };

  const handleDeleteFileA = (fileName) => {
    const updatedList = fileList.filter(file => file.autorizacionFile !== fileName);
    const updatedBase64Files = formik.values.documentsFileA.filter(file => file.autorizacionFile !== fileName);

    setFileList(updatedList);
    formik.setValues({
      ...formik.values,
      documentsFileA: updatedBase64Files,
    });
  };

  const handleDeleteFileO = (fileName) => {
    const updatedList = fileListO.filter(file => file.ordenMedicaFile !== fileName);
    const updatedBase64Files = formik.values.documentsFileO.filter(file => file.ordenMedicaFile !== fileName);

    setFileListO(updatedList);
    formik.setValues({
      ...formik.values,
      documentsFileO: updatedBase64Files,
    });
  };

  const limpiarFormulario = () => {
    formik.resetForm();
    setCentroMedicos([]);
    setEspecialidades([]);

    setCentroMedicoSelected({
      id: null,
      name: "Seleccione"
    });
    setEspecialidadSelected({
      id: null,
      name: "Seleccione"
    })

    obtenerCentroMedico();
    obtenerEspecialidad();

    // Resetear listas de archivos
    setFileList([]);
    setFileListO([]);

    formik.setValues({
      idCentroMedico: null,
      idEspecialidad: null,
      documentsFileA: [],
      documentsFileO: [],
    });
  };


  const seleccionarCentroMedico = (id, name, text) => {
    formik.setFieldValue("idCentroMedico", id);
    setCentroMedicoSelected({
      id: id,
      name: text
    });

    if (id == 3) {
      setEspecialidadSelected({
        id: null,
        name: "Seleccione"
      });
    } else {
      formik.setFieldValue("idEspecialidad", null); // <- Limpieza aquí
      setEspecialidadSelected({
        id: null,
        name: "Seleccione"
      });
    }
  };

  const seleccionarEspecialidad = (id, name, text) => {
    formik.setFieldValue("idEspecialidad", id);
    setEspecialidadSelected({
      id: id,
      name: text
    });
  };

  const obtenerCentroMedico = async () => {

    return myAxios({
      url: `${process.env.REACT_APP_GATEWAY_2}/patient/api/v1/centromedico/obtenercentrosmedicos`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        USERTOKEN: user.user.data.Token,
        Authorization: `Bearer ${user.user.data.appToken}`,
      },
    }).then((response) => {

      const dataResult = response.data.data.result.map(item => ({
        id: item.idCentroMedico,
        name: item.nombre.trim()
      }));

      setCentroMedicos(dataResult);
    })
  };

  const obtenerEspecialidad = async () => {

    return myAxios({
      url: `${process.env.REACT_APP_GATEWAY_2}/patient/api/v1/especialidades/obtenerespecialidades`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        USERTOKEN: user.user.data.Token,
        Authorization: `Bearer ${user.user.data.appToken}`,
      },
    }).then((response) => {

      const dataResult = response.data.data.result.map(item => ({
        id: item.idEspecialidad,
        name: item.nombreEspecialidad.trim()
      }));

      const dataResultSorted = dataResult.sort((a, b) =>
        a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
      );

      setEspecialidades(dataResultSorted);
    })
  };

  useEffect(() => {
    obtenerCentroMedico();
    obtenerEspecialidad();
  }, []);

  return (
    <MessageContext.Provider value={responseData}>
      <section>
        <div className="container p-3">
          <section className="section_contacto_pshb pb-5">

            <ModalConfirmChangeComponent
              visible={MessageToggle.toggle}
              onToggle={MessageToggle.onToggle}
            />

            <div
              className="container-fluid p-3 container_mobiles"
              style={{ marginTop: "3rem" }}
            >
              <div className="row pb-1">
                <div className="col-lg-12">
                  <h2 className="section_contacto_titulo-hb title_mobiles">
                    <b className="section_contacto_titulo-hb">
                      Envío de Documentación
                    </b>
                  </h2>

                  <p className="subtitulo-hb">
                    Adjunte la autorización de su cobertura médica para el procedimiento en el Hospital Británico o la orden médica digital de otra institución.
                    <br /> Asegúrese de que los documentos sean legibles y coincidan con sus datos registrados.
                  </p>
                </div>
              </div>

              {/* FORM */}
              <div className="">
                <div className="row g-0">
                  {/* FORMULARIO */}
                  <div
                    className="col-12 col-lg-12 container-dejanos-consulta columna-contenido"
                    id="form-contacto-hb"
                  >
                    <form onSubmit={formik.handleSubmit}>
                      <div className="card card-refund b-radius-20 shadow-external">
                        <div className="g-0">
                          <div className="row">
                            <div className="section-date col-md-6 col-xl-6 mb-3">
                              <span className="label-pshb">
                                <input name="dni" type="hidden" value={formik.values.dni} onChange={formik.handleChange} />
                                Centro médico <span className="obligatorio">*</span>
                              </span>
                              <div className="input-icons-date-pshb-refund relative h-20">
                                <div style={{ position: "relative", width: "100%" }}>
                                  <select
                                    name="nombre"
                                    value={CentroMedicoSelected.id}
                                    onChange={(e) => {
                                      const selectedId = parseInt(e.target.value, 10);
                                      const selectedItem = CentroMedicos.find((item) => item.id === selectedId);

                                      seleccionarCentroMedico(
                                        selectedId,
                                        "idCentroMedico",
                                        selectedItem?.name || "Seleccione"
                                      );
                                    }}
                                    className="form-control b-radius-20 shadow-blue select-atencion"
                                  >
                                    <option value="">Seleccione un centro médico</option>
                                    {CentroMedicos.map((item) => (
                                      <option key={item.id} value={item.id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                              <div className="mt-3">
                                {formik.touched.idCentroMedico ? (
                                  <span className="error-label-pshb">
                                    {formik.errors.idCentroMedico}
                                  </span>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>

                            {CentroMedicoSelected.id == 1 && (
                              <div className="section-date col-md-6 col-xl-6 mb-3">
                                <span className="label-pshb">
                                  Especialidad <span className="obligatorio">*</span>
                                </span>
                                <div className="input-icons-date-pshb-refund relative h-20">
                                  <div style={{ position: "relative", width: "100%" }}>
                                    <Select
                                      name="idEspecialidad"
                                      value={
                                        especialidades
                                          .map((item) => ({ value: Number(item.id), label: item.name }))
                                          .find((option) => option.value === especialidadSelected.id) || null
                                      }
                                      onChange={(selectedOption) => {
                                        if (!selectedOption) {
                                          formik.setFieldValue("idEspecialidad", null);
                                          setEspecialidadSelected({
                                            id: null,
                                            name: "Seleccione",
                                          });
                                          return;
                                        }

                                        seleccionarEspecialidad(
                                          selectedOption.value,
                                          "idEspecialidad",
                                          selectedOption.label
                                        );
                                      }}
                                      onBlur={() => formik.setFieldTouched("idEspecialidad", true)}
                                      options={especialidades.map((item) => ({
                                        value: Number(item.id),
                                        label: item.name,
                                      }))}
                                      placeholder="Seleccione una especialidad"
                                      isSearchable
                                      noOptionsMessage={() => "Sin resultados"}
                                      className="select-atencion"
                                      styles={selectStyles}
                                    />
                                  </div>
                                </div>
                                <div className="mt-3">
                                  {formik.touched.idEspecialidad && formik.errors.idEspecialidad && (
                                    <span className="error-label-pshb">
                                      {formik.errors.idEspecialidad}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}

                          </div>

                          <div className="row mt-2 justify-content-center">
                            {/* ARCHIVOS */}
                            <div className="col-md-12 col-lg-5 col-sm-12">
                              <span className="label-file">
                                Autorizaciones
                              </span>
                              <div>
                                <div className="custom-load-icon" style={{ height: "30px", minHeight: "30px" }}
                                  onClick={() => document.getElementById("file-autorizaciones").click()}>
                                  <FontAwesomeIcon icon={faPaperclip} />
                                  <span>Adjuntar</span>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", marginLeft: "100px" }}>
                                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                    <span className="round-label w-100 shadow-blue"
                                      style={{ maxWidth: "300px", display: "flex", alignItems: "center", minHeight: "30px", height: "30px" }}>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <input
                                id="file-autorizaciones"
                                type="file"
                                accept=".pdf,.png,.jpg,.jpeg"
                                multiple
                                onChange={(e) => handleFileChangeA(e, "autorizacion")}
                                style={{ display: "none" }}
                              />
                              <div className="mt-3">
                                {(formik.touched.documentsFileA || formik.submitCount > 0) && formik.errors.documentsFileA && (
                                  <span className="error-label-pshb">
                                    {formik.errors.documentsFileA}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-md-12 col-lg-5 col-sm-12">
                              <span className="label-file">Ordenes médicas</span>
                              <div>
                                <div className="custom-load-icon" style={{ height: "30px", minHeight: "30px" }}
                                  onClick={() => document.getElementById("file-orden").click()}>
                                  <FontAwesomeIcon icon={faPaperclip} />
                                  <span>Adjuntar</span>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", marginLeft: "100px" }}>
                                  <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                    <span className="round-label w-100 shadow-blue"
                                      style={{ maxWidth: "300px", display: "flex", alignItems: "center", minHeight: "30px", height: "30px" }}>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <input
                                id="file-orden"
                                type="file"
                                accept=".pdf,.png,.jpg,.jpeg"
                                multiple
                                onChange={(e) => handleFileChangeO(e, "orden")}
                                style={{ display: "none" }}
                              />

                            </div>

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                margin: "30px 0px",
                              }}
                            >
                              <span id="aclaracion-archivos">
                                Los archivos deben estar en formato{" "}
                                <span className="enfasis">PDF</span>,{" "}
                                <span className="enfasis">PNG</span>,{" "}
                                <span className="enfasis">JPG</span> o{" "}
                                <span className="enfasis">JPEG</span> y no superar los 5MB
                              </span>
                            </div>
                          </div>

                          <div className="row mt-2 justify-content-center">
                            {/* ARCHIVOS */}
                            <div className="col-md-12 col-lg-5 col-sm-12 meca-factura">
                              {/* <span className="label-file">
                                Autorizaciones
                              </span>
                              */}
                              <Grid container spacing={2}>
                                <Grid item xs={12} md={12}>
                                  {/* <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
                                  {fileList.length > 0 ? "Archivos seleccionados" : ""}
                                </Typography> */}

                                  {fileList.some(file => file.tipo === "autorizacion") && (
                                    <>
                                      {/* <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
                                      Archivos de Autorizaciones
                                    </Typography> */}
                                      <Demo>
                                        <List dense>
                                          {fileList
                                            .filter(file => file.tipo === "autorizacion")
                                            .map((file, index) => (
                                              <ListItem
                                                key={`aut-${index}`}
                                                sx={{ border: "2px solid #4CAF50", borderRadius: "8px", marginBottom: "8px", padding: "8px" }}
                                                secondaryAction={
                                                  <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteFileA(file.autorizacionFile)}>
                                                    <img src={imgEliminar} className="iconosAtencion" alt="..." />{" "}
                                                  </IconButton>
                                                }
                                              >
                                                <ListItemText primary={file.autorizacionFile} />
                                              </ListItem>
                                            ))}
                                        </List>
                                      </Demo>
                                    </>
                                  )}
                                </Grid>
                              </Grid>

                            </div>

                            <div className="col-md-12 col-lg-5 col-sm-12">
                              {/* <span className="label-file">Ordenes médicas</span> */}
                              {fileListO.some(file => file.tipo === "orden") && (
                                <>
                                  {/* <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
                                      Archivos de Órdenes médicas
                                    </Typography> */}
                                  <Demo>
                                    <List dense>
                                      {fileListO
                                        .filter(file => file.tipo === "orden")
                                        .map((file, index) => (
                                          <ListItem
                                            key={`ord-${index}`}
                                            sx={{ border: "2px solid #4CAF50", borderRadius: "8px", marginBottom: "8px", padding: "8px" }}
                                            secondaryAction={
                                              <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteFileO(file.ordenMedicaFile)}>
                                                <img title="Eliminar" src={imgEliminar} width={"80px"} className="iconosAtencion" alt="..." />{" "}
                                              </IconButton>
                                            }
                                          >
                                            <ListItemText primary={file.ordenMedicaFile} />
                                          </ListItem>
                                        ))}
                                    </List>
                                  </Demo>
                                </>
                              )}
                            </div>

                          </div>

                          <div className="row">
                            <div className="col-md-12 text-center mt-5">
                              <Button
                                type="submit"
                                disabled={loading}
                                className="btn btn-hb-primary-without-border shadow-blue"
                              >
                                {!loading ? (
                                  "Enviar documentos"
                                ) : (
                                  <>
                                    <span className="spinner-grow spinner-grow-sm"></span>
                                    <span className="spinner-grow spinner-grow-sm"></span>
                                    <span className="spinner-grow spinner-grow-sm"></span>
                                  </>
                                )}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>

                  </div>

                </div>
                <div className="row g-0 fila-acepto">
                  <div
                    className="col-12 col-lg-8"
                    style={{ padding: "0px 20px" }}
                  ></div>
                </div>
              </div>

            </div>
          </section>
        </div>
      </section>
    </MessageContext.Provider>
  );
};

export default AdjuntarDocumentacionComponent;